import Footer from '../footer'
import LanguageSwitch from '../LanguageSwitch'
import Link from 'next/link'
import Image from 'next/future/image'
import { useEffect, useState } from 'react'
import { useTranslation } from 'next-i18next'

export default function DeveloperLayout ({ children }) {
  const [isMoving, setIsMoving] = useState(false)
  const { t } = useTranslation('header')

  useEffect(() => {
    document.addEventListener('scroll', () => {
      if (window.scrollY > 0) {
        setIsMoving(true)
      } else {
        setIsMoving(false)
      }
    })
  }, [])

  return (
    <>
      <header className={`${isMoving ? 'header--shadow' : ''} header--fixed`}>
        <nav className="navbar navbar-expand-lg">
          <div className="container d-flex">
            <Link href="/">
              <a className="navbar-brand">
                {!isMoving && (
                  <Image
                    alt=""
                    src="/images/logo-aqua.svg"
                    width={150}
                    height={30}
                  />
                )}
                {
                  isMoving && (
                    <Image
                      alt=""
                      src="/images/logo.svg"
                      width={150}
                      height={30}
                    />
                  )
                }
              </a>
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#header"
              aria-controls="header"
              aria-expanded="false"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse  bg-transparent d-lg-flex justify-content-start mx-5">
              <ul className="navbar-nav mb-2 mb-lg-0 gap-lg-3">
                {
                  false && (
                    <li className="nav-item">
                      <Link href="/page/features">
                        <a className={`nav-link text-dark ${isMoving ? 'text-dark' : 'text-white'}`}>
                          {t('seller.features')}
                        </a>
                      </Link>
                    </li>
                  )
                }
                <li className="nav-item">
                  <Link href="/page/pricing">
                    <a className={`nav-link text-dark ${isMoving ? 'text-dark' : 'text-white'}`}>
                      {t('seller.pricing')}
                    </a>
                  </Link>
                </li>
              </ul>
            </div>
            <div
              className="collapse navbar-collapse bg-transparent d-lg-flex justify-content-end"
              id="header"
            >
              <ul className="navbar-nav mb-2 mb-lg-0 gap-lg-3">
                <li className="nav-item">
                  <Link href="/login">
                    <a className={`nav-link text-dark ${isMoving ? 'text-dark' : 'text-white'}`}>
                      {t('seller.login')}
                    </a>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link href="/sign-up-developer">
                    <a className={'nav-link btn btn-turquoise px-3 py-2'}>
                      {t('seller.signup')}
                    </a>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </header>
      <main>{children}</main>
      <Footer />
      <LanguageSwitch />
    </>
  )
}
